import { render, staticRenderFns } from "./CardPurchaseRequest.vue?vue&type=template&id=018f42e6&"
import script from "./CardPurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./CardPurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports